import { useCallback, cloneElement } from 'react';

import { useMouseDownDrag } from '../hooks';

const DraggableHandler = ({ id, children }) => {
  const onMouseDownDrag = useMouseDownDrag();

  const handleMouseDown = useCallback(
    (e) => onMouseDownDrag(e.nativeEvent, id),
    [id, onMouseDownDrag]
  );

  return cloneElement(children, { onMouseDown: handleMouseDown });
};

export default DraggableHandler;
